// src/services/api.js
import { getDevUserId } from "./devIdentity";
// const BASE_URL = "https://32c4-196-191-240-81.ngrok-free.app";
// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
// api.js
const BASE_URL =
  window.APP_CONFIG?.API_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:3001";
export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

function getInitData() {
  if (window.Telegram?.WebApp?.initData) return window.Telegram.WebApp.initData;
  return localStorage.getItem("dev_init_data") || "";
}

async function apiFetch(path, options = {}) {
  const devUserId = getDevUserId();
  const headers = {
    "Content-Type": "application/json",
    "x-telegram-init-data": getInitData(),
    "ngrok-skip-browser-warning": "true",
    ...(devUserId ? { "x-dev-user-id": devUserId } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });

  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      message = body.error || message;
    } catch (_) {}
    throw new ApiError(message, res.status);
  }
  return res.json();
}

export const api = {
  getMe() {
    return apiFetch("/api/auth/me");
  },
  updateSoundSetting(muted) {
    return apiFetch("/api/auth/me/settings", {
      method: "PATCH",
      body: JSON.stringify({ soundMuted: muted }),
    });
  },
  getGameHistory(before) {
    const q = before ? `?before=${encodeURIComponent(before)}` : "";
    return apiFetch(`/api/games/history${q}`);
  },
  getGameHistorySummary() {
    return apiFetch("/api/games/history/summary");
  },
  getWallet(before) {
    const q = before ? `?before=${encodeURIComponent(before)}` : "";
    return apiFetch(`/api/wallet${q}`);
  },
  devAddFunds(amount, wallet = "play") {
    return apiFetch("/api/wallet/add", {
      method: "POST",
      body: JSON.stringify({ amount, wallet }),
    });
  },
  getRooms() {
    return apiFetch("/api/games/rooms");
  },
  getCartelas(roomId) {
    return apiFetch(`/api/cartelas?roomId=${roomId}`);
  },
};
